import { render, staticRenderFns } from "./prompt_statement.vue?vue&type=template&id=36358346&scoped=true&"
import script from "./prompt_statement.vue?vue&type=script&lang=js&"
export * from "./prompt_statement.vue?vue&type=script&lang=js&"
import style0 from "./prompt_statement.vue?vue&type=style&index=0&id=36358346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36358346",
  null
  
)

export default component.exports